<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__account}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="账户名称：">
          <el-input
            v-model="dataForm.name"
            placeholder="账户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="$hasPermission('trade:account:save')"
            type="primary"
            @click="addOrUpdateHandle()"
            >{{ $t("add") }}</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @selection-change="dataListSelectionChangeHandle"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          header-align="center"
          align="center"
          width="50"
          label="行号"
        ></el-table-column>
        <el-table-column
          prop="receiptCode"
          label="发票号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="makeCompanyName"
          label="加工单位"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="agreementCode"
          label="合同号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="productCode"
          label="品番号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
            prop="productName"
            label="品名"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
          prop="color"
          label="颜色"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="size"
          label="规格"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="count"
          label="数量"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="salePrice"
          label="单价"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            {{moneyFormat(scope.row.salePrice)}}
        </template>
        </el-table-column>
        <el-table-column
          prop="sellAmount"
          label="外销额"
          header-align="center"
          align="center"
        >
        <template slot-scope="scope">
            {{moneyFormat(scope.row.salePrice*scope.row.count)}}
        </template>
        </el-table-column>
        <el-table-column
          prop="costPrice"
          label="成本价格"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          label="成本金额"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            {{moneyFormat(scope.row.costPrice*scope.row.count)}}
          </template>
        </el-table-column>
<!--        <el-table-column-->
<!--          prop="otherCost1"-->
<!--          label="费用和包装检品费"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--        ></el-table-column>-->
<!--        <el-table-column-->
<!--          prop="otherCost2"-->
<!--          label="海运费佣金"-->
<!--          header-align="center"-->
<!--          align="center"-->
<!--        ></el-table-column>-->
        <el-table-column
          label="换汇"
          header-align="center"
          align="center"
          prop="rate"
        >
        </el-table-column>
        <el-table-column
          prop="shipDate"
          label="日期"
          header-align="center"
          align="center"
          width="130"
        >
        </el-table-column>
        <el-table-column
          prop="customerName"
          label="客户名称"
          header-align="center"
          align="center"
        ></el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from "@/mixins/view-module";
import BigNumber from 'bignumber.js'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/trade/boxform/report",
        getDataListIsPage: true,
        exportURL: "/trade/account/export",
      },
      dataForm: {
        name: "",
      },
    };
  },
  methods: {
    beforeTableBinding(dataList) {
      dataList.forEach((item) => {
        let costPrice=new BigNumber(item.costPrice||0)
        let salePrice=new BigNumber(item.salePrice||0)
      item.rate= costPrice.dividedBy(salePrice.dividedBy(100)).toFixed(4)
      });
    },
  },
  components: {},
};
</script>
